module.exports = __webpack_public_path__ + "img/lifecoach3.3668dec6.jpg";